import { render, staticRenderFns } from "./EncuestaResponderProlipa.vue?vue&type=template&id=486be1d2&scoped=true"
import script from "./EncuestaResponderProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaResponderProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaResponderProlipa.vue?vue&type=style&index=0&id=486be1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486be1d2",
  null
  
)

export default component.exports